"use client";
import { jsx as m } from "react/jsx-runtime";
import * as l from "@radix-ui/react-separator";
import { cva as c } from "class-variance-authority";
import { forwardRef as h } from "react";
import { twMerge as p } from "tailwind-merge";
import { cn as d } from "../../../utils/utils.mjs";
const g = c("border-none shrink-0", {
  variants: {
    orientation: {
      horizontal: "w-full",
      vertical: "h-full"
    },
    thickness: {
      thin: "",
      thick: ""
    },
    color: {
      light: "bg-gray-300",
      dark: "bg-gray-800",
      primary: "bg-blue-600",
      secondary: "bg-green-600"
    },
    marginY: {
      none: "my-0",
      small: "my-2",
      medium: "my-4",
      large: "my-6"
    }
  },
  compoundVariants: [
    { orientation: "horizontal", thickness: "thin", className: "h-[2px]" },
    { orientation: "horizontal", thickness: "thick", className: "h-[4px]" },
    { orientation: "vertical", thickness: "thin", className: "w-[2px]" },
    { orientation: "vertical", thickness: "thick", className: "w-[4px]" }
  ],
  defaultVariants: {
    orientation: "horizontal",
    thickness: "thin",
    color: "light",
    marginY: "medium"
  }
}), f = h(
  ({ thickness: t, color: r, marginY: a, orientation: i = "horizontal", decorative: o = !0, className: e, ...n }, s) => /* @__PURE__ */ m(
    l.Root,
    {
      "data-slot": "divider",
      orientation: i,
      decorative: o,
      className: p(d(g({ orientation: i, thickness: t, color: r, marginY: a })), e),
      ...n,
      ref: s
    }
  )
);
f.displayName = "Divider";
export {
  f as Divider
};
